/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Tool_Grants_All_ToolsInputs */



/**
* | output |
* | --- |
* | "All tools, including ones added later" |
*
* @param {Spaces_Tool_Grants_All_ToolsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tool_grants_all_tools = /** @type {((inputs?: Spaces_Tool_Grants_All_ToolsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tool_Grants_All_ToolsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Tools, auch später hinzukommende")
	return /** @type {LocalizedString} */ ("All tools, including ones added later")
});